import { BidAwardLockup, Card, Row } from '@tempmee/react';
import { useBestInDentalWinnerCredential } from '~/hooks/useBestInDentalWinnerCredential';

/**
 * The Best in Dental winner credential under a location's header card (gate
 * answer P1 (a)). Renders nothing for an office that has not won. The credential
 * reads the office the app is scoped to, so the page shows it on that office only.
 */
export const BestInDentalWinnerCard = () => {
  const { isWinner, year } = useBestInDentalWinnerCredential();

  if (!isWinner) return null;

  return (
    <Card className="rounded-lg p-4">
      <Row justify="center">
        <BidAwardLockup
          elevated
          layout="split"
          label="Best in Dental"
          year={year}
          data-cy="bid-location-winner"
        />
      </Row>
    </Card>
  );
};
